export default function getIntervenantsWithArchivedContact(intervenants) {
  if (!intervenants) return [];
  return intervenants.filter(intervenant => intervenant.contact?.archive);
}
